import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20atmosphere%20with%20warm%20golden%20spotlights%20illuminating%20velvet%20curtains%2C%20floating%20dust%20particles%20in%20light%20beams%2C%20dramatic%20shadow%20play%2C%20luxurious%20movie%20theater%20interior%20with%20empty%20red%20seats%2C%20atmospheric%20and%20mysterious%20cinema%20aesthetic%2C%20professional%20cinematography%20lighting%2C%20deep%20contrast%2C%20artistic%20composition&width=1800&height=800&seq=hero-bg-cinema-01&orientation=landscape"
        alt="星空影院 - 热播电视剧高分剧集在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
          星空影院
        </h1>
        <p className="text-base md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed">
          聚合热播电视剧、高分剧集全集在线观看<br />
          韩剧在线 · 美剧在线 · 国产剧大全 · 免费高清追剧
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            立即追剧
            <span className="ml-2">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 hover:border-white/60 text-white rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-12">
          {[
            { label: '剧集总数', value: '12,000+' },
            { label: '高清画质', value: '4K HDR' },
            { label: '每日更新', value: '50+部' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center">
          <div className="w-1.5 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}